<template>
    <div>
        <div class="relative flex flex-wrap items-center justify-between mt-2 mb-5">
            <div>
                <h4 class="title">{{ title }}</h4>
            </div>
            <div>
                <slot name="header-buttons"></slot>
            </div>
        </div>

        <slot v-if="false" name="header-buttons"></slot>

        <div class="flex justify-center pb-4" infinite-wrapper>
            <table class="w-full table-auto text-md bg-white shadow-md rounded-lg mb-4">
                <thead>
                    <slot name="table-header" :setOrder="setOrder"></slot>
                </thead>

                <slot name="table-filters" :filters="filters"></slot>

                <transition-group tag="tbody" name="list" mode="out-in">
                    <tr
                        v-for="entry in entries"
                        :key="entry.id"
                        class="border-b hover:bg-gray-200 bg-gray-100 transition-fast"
                    >
                        <slot name="row" :entry="entry"></slot>
                    </tr>
                </transition-group>
            </table>

            <infinite-loading
                @infinite="paginate"
                ref="infiniteLoading"
                :force-use-infinite-wrapper="true"
                v-if="pagination"
            >
                <div slot="no-more"></div>
                <div slot="spinner"></div>

                <div slot="no-results"></div>

                <div slot="error" slot-scope="{ trigger }">
                    <div
                        class="d-flex flex-column align-items-center justify-content-center card-bg-secondary p-5 bottom-radius"
                    >
                        <svg
                            v-if="false"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 60 60"
                            class="fill-text-color"
                            style="width: 200px"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M7 10h41a11 11 0 0 1 0 22h-8a3 3 0 0 0 0 6h6a6 6 0 1 1 0 12H10a4 4 0 1 1 0-8h2a2 2 0 1 0 0-4H7a5 5 0 0 1 0-10h3a3 3 0 0 0 0-6H7a6 6 0 1 1 0-12zm14 19a1 1 0 0 1-1-1 1 1 0 0 0-2 0 1 1 0 0 1-1 1 1 1 0 0 0 0 2 1 1 0 0 1 1 1 1 1 0 0 0 2 0 1 1 0 0 1 1-1 1 1 0 0 0 0-2zm-5.5-11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm24 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm1 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-14-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm22-23a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM33 18a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a1 1 0 0 1-1 1h-1a1 1 0 0 0 0 2h1a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 0-2h-1z"
                            />
                        </svg>

                        <span>
                            There was an error,
                            <a href="#" @click.prevent="trigger">reload</a>.
                        </span>
                    </div>
                </div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
import _ from "lodash"
import qs from "qs"

export default {
    props: {
        endpoint: {
            type: String,
        },
        title: {
            type: String,
        },
        pagination: {
            type: Boolean,
            default: true,
        },
        params: {
            type: Object,
            default: () => {
                {
                }
            },
        },
    },

    data() {
        return {
            entries: [],
            page: 1,
            filters: this.params ? this.params : {},
            ready: false,
            order: null,
        }
    },

    mounted() {
        if (!this.pagination) {
            this.refresh()
        }
    },

    methods: {
        setOrder(param) {
            if (this.order == param) {
                this.order = `-${param}`
            } else {
                this.order = param
            }

            this.refresh()
        },

        updateEntry(updatedEntry) {
            let entry = this.entries.find(
                (entry) => entry.id === updatedEntry.id
            )
            Object.assign(entry, updatedEntry)
        },

        paginate($state, refresh = false) {
            this.ready = false

            this.loadEntries((entries, next) => {
                this.ready = true

                if (refresh == true) {
                    this.entries = []
                }

                if (entries.length && next) {
                    this.entries.push(...entries)
                    this.page++
                    $state.loaded()
                } else if (entries.length) {
                    this.entries.push(...entries)
                    $state.complete()
                } else {
                    $state.complete()
                }
            })
        },

        refresh() {
            if (this.pagination) {
                this.page = 1
                this.$refs.infiniteLoading.isFirstLoad = true
                this.paginate(this.$refs.infiniteLoading.stateChanger, true)
            } else {
                this.ready = false
                this.loadEntries((entries) => {
                    this.entries = entries
                    this.ready = true
                })
            }
        },

        loadEntries(after) {
            let endpoint = this.endpoint

            axios
                .get(endpoint, {
                    params: {
                        page: this.page,
                        filters: this.filters,
                        order: this.order,
                    },
                    paramsSerializer: (params) => {
                        return qs.stringify(params)
                    },
                })
                .then((response) => {
                    if (_.isFunction(after)) {
                        after(response.data.data, !!response.data.links.next)
                    }
                })
        },

        search() {
            this.debouncer(() => {
                this.refresh()
            })
        },
    },

    watch: {
        filters: {
            handler(value, oldValue) {
                this.search()
            },
            deep: true,
        },
    },
}
</script>